import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-dvh grid place-items-center p-6">
      <div className="text-center max-w-md">
        <div className="text-7xl font-display font-semibold tracking-tight">404</div>
        <p className="mt-3 text-muted-foreground">The page you're looking for doesn't exist or you don't have access.</p>
        <Button asChild className="mt-6"><Link to="/login">Go to login</Link></Button>
      </div>
    </div>
  );
}
